<template>
  <div>
    <div class="row mt10 name-box">
      <div class="col-md-12">
        <div class="row">
          <router-link :to="localizedRoute(getMainCategory.url_path + '?designer=' + getCurrentProduct.designer)" class="fs-medium-small weight-400 cl-black author uppercase pl10">
            {{ designerCheck }}
          </router-link>
          <div id="6ea25396-b018-405b-8836-c37b4597eb3c" />
          <script defer type="application/javascript" :src="`https://trustmate.io/api/widget/6ea25396-b018-405b-8836-c37b4597eb3c/script?product=${getCurrentProduct.parentSku}`" />
        </div>
        <h1 class="mb0 mt0 product-name weight-600 serif capitalize">
          {{ getCurrentProduct.name | htmlDecode }}
          <AddToWishlist :product="getCurrentProduct" class="wishlist-button" />
        </h1>
        <p class="fs-medium-small cl-light-gray mt10">
          {{ getAllAttributeList('retail_price') }} {{ getCurrentProduct.retail_price | price(storeView) }}
        </p>
        <SubscriptionRent v-if="isSubscriptionAvaliable" class="mb15" @click.native="updatePeriod()" :first-available="firstAvailableSection" />
        <SingleRent v-if="!isLogged || !isEnoughPoints || !isSubscriptionAvaliable" class="mb15" @click.native="updatePeriod()" :first-available="firstAvailableSection" />
        <TryOn v-if="isTryOn && !isSubscriptionAvaliable" class="mb15" @click.native="updatePeriod()" :first-available="firstAvailableSection" />
      </div>
    </div>
    <product-custom-options
      v-if="getCurrentProduct.custom_options && getCurrentProduct.custom_options.length > 0"
      :product="getCurrentProduct"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ProductMixin } from 'theme/components/core/blocks/Product-v2/ProductMixin.ts'
import SingleRent from './Rent/SingleRent.vue'
import SubscriptionRent from './Rent/SubscriptionRent.vue'
import TryOn from './Rent/TryOn.vue'

export default {
  components: {
    SingleRent,
    SubscriptionRent,
    TryOn
  },
  mixins: [ProductMixin],
  computed: {
    ...mapGetters({
      getPeriods: 'calendar/getPeriods',
      getUserBalance: 'user/getBalance',
      isLogged: 'user/isLoggedIn'
    }),
    isSubscriptionAvaliable () {
      return this.getCurrentProduct.subscription_points
    },
    isEnoughPoints () {
      return this.getUserBalance >= 1
    },
    isTryOn () {
      return this.getPeriods && this.getPeriods.indexOf(2)
    },
    firstAvailableSection () {
      if (this.isSubscriptionAvaliable) {
        return 'With membership'
      } else {
        return 'One-time rental'
      }
    }
  },
  async mounted () {
    this.setAvaliableSourceCodes()
  },
  methods: {
    updatePeriod () {
      this.$store.dispatch('calendar/updateCalendarData')
    },
    setAvaliableSourceCodes () {
      if (this.getCurrentProduct.stock && this.getCurrentProduct.stock.source_codes && this.getCurrentProduct.stock.source_codes.length) {
        this.$store.commit('calendar/setAvailableDeliveries', this.getCurrentProduct.stock.source_codes)
      } else {
        this.$store.commit('calendar/setAvailableDeliveries', [])
      }
      this.$store.dispatch('calendar/loadCalendarData', { sku: this.getCurrentProduct.sku })
    }
  }
}
</script>

<style lang="scss" scoped>
.name-box {
  @media (max-width: 767px) {
    margin-bottom: 10px;
  }
}
.product-name {
  font-size: 28px;
  font-weight: 500;
  position: relative;
  .wishlist-button {
    position: absolute;
    right: 0;
    top: -7px;
  }
  @media (max-width: 767px) {
    font-size: 26px;
  }
}
</style>
